import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { GraduationCap, Loader2, CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  // checking | done | invalid
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!token) {
      setStatus("invalid");
      return;
    }
    (async () => {
      try {
        await api.post("/auth/verify-email", { token });
        setStatus("done");
      } catch {
        setStatus("invalid");
      }
    })();
  }, [token]);

  return (
    <div
      data-testid="verify-email-page"
      className="min-h-screen bg-brand-bg brand-grid-bg flex items-center justify-center px-4 py-16"
    >
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2.5 justify-center mb-8">
          <span className="inline-flex h-11 w-11 items-center justify-center rounded-sm bg-brand-blue text-white">
            <GraduationCap size={22} strokeWidth={2} />
          </span>
          <div className="leading-tight">
            <div className="wordmark text-brand-blue text-xl">Buro Academy</div>
            <div className="text-xs text-brand-muted -mt-0.5">Burocratica Servizi</div>
          </div>
        </div>

        <div className="bg-white border border-brand-line rounded-sm shadow-sm p-8">
          <div className="gold-rule" />

          {status === "checking" && (
            <div className="flex items-center gap-2 text-sm text-brand-muted py-4">
              <Loader2 size={18} className="animate-spin" /> Conferma dell'indirizzo in corso…
            </div>
          )}

          {status === "done" && (
            <div data-testid="verify-done">
              <div className="flex items-center gap-2 text-brand-blue mb-3">
                <CheckCircle2 size={22} />
                <h1 className="text-2xl text-brand-ink">Email confermata</h1>
              </div>
              <p className="text-sm text-brand-muted mb-6">
                Il tuo indirizzo è stato verificato. Ora puoi accedere al tuo account.
              </p>
              <Link to="/login" className="btn-primary w-full inline-flex items-center justify-center gap-2">
                Vai all'accesso
              </Link>
            </div>
          )}

          {status === "invalid" && (
            <div data-testid="verify-invalid">
              <h1 className="text-2xl text-brand-ink mb-2">Link non valido</h1>
              <p className="text-sm text-brand-muted mb-6">
                Il link di conferma è scaduto, è già stato utilizzato oppure non è
                corretto. Registrati di nuovo o richiedi assistenza.
              </p>
              <Link to="/login" className="btn-primary w-full inline-flex items-center justify-center gap-2">
                Vai all'accesso
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
